import type { TFunction } from 'i18next';

/**
 * Переводит типовые статьи из БД (часто на русском) в строки текущей локали.
 * Неизвестный текст возвращается как есть.
 */
export function translateBalanceArticle(article: string, t: TFunction): string {
  const a = article.trim();
  if (!a) return '';

  let m: RegExpExecArray | null;

  m = /^Прибыль с мэтча\s*#(\d+)\s*$/i.exec(a);
  if (m) return t('balanceHistory.art_profitMatch', { id: m[1] });

  m = /^Обновление расч[её]тного баланса для пользователя\s+(.+)$/i.exec(a);
  if (m) return t('balanceHistory.art_salaryUpdate', { name: m[1].trim() });

  m = /^Зачисление по выплате VND\s*#(\d+)\s*$/i.exec(a);
  if (m) return t('balanceHistory.art_vndPayoutCredit', { id: m[1] });

  m = /^Списание по закрытию vnd_qr заявки WT\s*#(\d+)\s*$/i.exec(a);
  if (m) return t('balanceHistory.art_vndQrIntakeCloseDebit', { wt: m[1] });

  if (/^Перевод внутри команды\s*$/i.test(a)) {
    return t('balanceHistory.art_teamTransfer');
  }

  if (/^Ручная корректировка баланса\s*$/i.test(a)) {
    return t('balanceHistory.art_manualAdjust');
  }

  m =
    /^Начисление по закрытию мэтча с проблемой Airex #(.+?) \(WT #(\d+), Match #(\d+)\)\s*$/i.exec(
      a
    );
  if (m) {
    return t('balanceHistory.art_accrualProblem', { order: m[1].trim(), wt: m[2], match: m[3] });
  }

  m = /^Начисление по закрытию мэтча Airex #(.+?) \(WT #(\d+), Match #(\d+)\)\s*$/i.exec(a);
  if (m) {
    return t('balanceHistory.art_accrualMatch', { order: m[1].trim(), wt: m[2], match: m[3] });
  }

  m =
    /^Транзакция закрытие мэтча для AirEX заявки #(.+?) \(WT #(\d+), Match #(\d+)\)\s*$/i.exec(a);
  if (m) {
    return t('balanceHistory.art_txCloseMatch', { order: m[1].trim(), wt: m[2], match: m[3] });
  }

  m = /^Компенсация партнёру при отмене проблемной заявки WT #(\d+) \(Match #(\d+)\)\s*$/i.exec(a);
  if (m) {
    return t('balanceHistory.art_compensation', { wt: m[1], match: m[2] });
  }

  return a;
}
